// extracted by mini-css-extract-plugin
module.exports = {"container":"JobBoard_container__3RHsp","board":"JobBoard_board__23tE_"};